export const validateEmptyPhoneNumber = (value) => {
  if (!value || value === '') {
    return true;
  }
  const prefixRE = new RegExp(`^\\+[0-9]{2,4}\\s*$`);
  return prefixRE.test(value);
};
